import { createIcon } from '@chakra-ui/react';

export const EmailNotificationIcon = createIcon({
  displayName: 'EmailNotificationIcon',
  viewBox: '0 0 32 32',
  defaultProps: {
    fill: 'none',
    height: '4',
    width: '4',
  },
  path: (
    <>
      <path
        d="M25.7782 8.38794C26.8213 8.38796 27.6677 9.23351 27.6678 10.2766V15.1682H25.6678V11.55L17.1473 18.0667C16.4701 18.5844 15.5296 18.5843 14.8524 18.0667L6.33191 11.55V22.6116H14.6669V24.6116H6.22058C5.17757 24.6114 4.33206 23.7659 4.33191 22.7229V10.2766C4.33208 9.2336 5.17757 8.38811 6.22058 8.38794H25.7782ZM15.9999 16.426L23.8964 10.3879H8.10339L15.9999 16.426Z"
        fill="currentColor"
      />
      <path
        d="M23.333 16.5002C27.383 16.5002 30.6668 19.7833 30.667 23.8333C30.667 27.8833 27.3831 31.1672 23.333 31.1672C19.2831 31.1671 16 27.8832 16 23.8333C16.0002 19.7834 19.2832 16.5004 23.333 16.5002ZM21.8311 26.3127C21.8311 27.1426 22.5042 27.8156 23.334 27.8157C24.1636 27.8153 24.8369 27.1424 24.8369 26.3127H23.6094C23.6094 26.4645 23.4856 26.5878 23.334 26.5881C23.1822 26.588 23.0596 26.4646 23.0596 26.3127H21.8311ZM23.334 19.8547C21.834 19.8548 20.7047 21.1175 20.5059 22.3469L20.0889 24.9397C20.0145 25.4048 20.3742 25.8232 20.8428 25.8235H25.8242C26.293 25.823 26.653 25.404 26.5781 24.9387C26.5021 24.4676 26.2896 23.1488 26.1621 22.3489C25.966 21.1183 24.8329 19.8552 23.334 19.8547ZM23.334 21.0833C24.125 21.0838 24.8304 21.7973 24.9492 22.5413C25.0425 23.1269 25.1817 23.9901 25.2793 24.5959H21.3877C21.4848 23.9905 21.6232 23.1285 21.7178 22.5432C21.8385 21.7961 22.5433 21.0833 23.334 21.0833Z"
        fill="currentColor"
      />
    </>
  ),
});
